<span [ngSwitch]="status.statusCode">
  <span class="badge-status grey" *ngSwitchCase="taskStatusEnum.New">
    {{status.title}}
  </span>
  <span class="badge-status success-with-border" *ngSwitchCase="taskStatusEnum.Active">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="taskStatusEnum.Waiting_First_Review">
    {{status.title}}
  </span>
  <span class="badge-status purple" *ngSwitchCase="taskStatusEnum.Modifications_Requested_From_First_Review">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="taskStatusEnum.Waiting_Final_Review">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="taskStatusEnum.Modifications_Requested_From_Final_Review">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="taskStatusEnum.Waiting_Final_Approval">
    {{status.title}}
  </span>
  <span class="badge-status success-with-border" *ngSwitchCase="taskStatusEnum.Final_Report_Approved">
    {{status.title}}
  </span>
  <span class="badge-status red_2" *ngSwitchCase="taskStatusEnum.Final_Report_Rejected">
    {{status.title}}
  </span>
  <span class="badge-status danger-with-border" *ngSwitchCase="taskStatusEnum.Overdue">
    {{status.title}}
  </span>
  <span class="badge-status success_2" *ngSwitchCase="taskStatusEnum.Published">
    {{status.title}}
  </span>
  <span class="badge-status danger-with-border" *ngSwitchCase="taskStatusEnum.Escalate_To_Related_Entity">
    {{status.title}}
  </span>
</span>